import { Category, City, Country } from "@graphql/types";
import { graphql } from "@helpers/graphql";

export type CityFooterFragment = Pick<
  City,
  | "id"
  | "name"
  | "hasOnlineTours"
  | "hasPrivateTours"
  | "hasSuppliers"
  | "hasTransportationTours"
  | "url"
> & {
  country: Pick<Country, "id" | "name" | "url">;
};

export interface CityFooterData {
  cities: City[];
  categories: Category[];
  city: City;
}

export const getCityFooterData = async (
  city: CityFooterFragment
): Promise<CityFooterData> => {
  const cities = await graphql.cities({
    first: 20,
    filters: {
      COUNTRIES_IDS: [city.country.id || ""],
      HAS_TOURS_OR_GUIDES: true,
    },
  });

  const categories = await graphql.getToursFiltersAvailable({
    filters: {
      CITIES_IDS: [city.id],
    },
  });

  return {
    cities: cities.cities.edges.map((city) => city.node),
    categories: categories.getToursFiltersAvailable.categories,
    city,
  } as CityFooterData;
};
